export default "__VITE_ASSET__DVwrgsir__"